import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import { withStyles } from '@material-ui/core/styles'
import withMobileDialog from '@material-ui/core/withMobileDialog'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight'
import TextField from '@material-ui/core/TextField'
import MenuItem from '@material-ui/core/MenuItem'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import FormControl from '@material-ui/core/FormControl'
import FormLabel from '@material-ui/core/FormLabel'
import { success } from '../../../store/actions/messageActions'
import { firestore } from '../../../firebase'

import styles from './styles'

const HeaderImage = require('../../../static/images/featured-profiles-form.jpg')

class UpgradeDialog extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      profile: props.profile,
      name: `${props.profile.firstName ? props.profile.firstName : ''} ${
        props.profile.lastName ? props.profile.lastName : ''
      }`,
      phone: props.profile.phone ? props.profile.phone : '',
      email: props.profile.email ? props.profile.email : props.user.email,
      companyId: props.business ? props.business.id : '',
      companyName: props.business ? props.business.name : '',
      companyUrl: props.business ? props.business.website : '',
      companyTaxId: '',
      companyLicense: '',
      companyStreet1: props.business ? props.business.address : '',
      companyStreet2: '',
      companyCity: props.business ? props.business.city : '',
      companyState: props.business ? props.business.state : '',
      companyZip: props.business ? props.business.zip : '',
      billingTerm: 1,
      errors: {},
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.profile && nextProps.profile.email && !this.state.profile) {
      this.setState({
        profile: nextProps.profile,
        name: `${nextProps.profile.firstName} ${nextProps.profile.lastName}`,
        phone: nextProps.profile.phone,
        email: nextProps.profile.email,
      })
    }
  }

  handleChange = name => event => {
    this.setState({ [name]: event.target.value })
  }

  isValid = () => {
    let isValid = true
    const errors = {}

    if (!this.state.name) {
      isValid = false
      errors.name = 'Name is Required'
    }

    if (!this.state.phone) {
      isValid = false
      errors.phone = 'Phone is Required'
    }

    if (!this.state.email) {
      isValid = false
      errors.email = 'Email is Required'
    }

    if (!this.state.companyName) {
      isValid = false
      errors.companyName = 'Company Name is Required'
    }

    if (!this.state.companyTaxId) {
      isValid = false
      errors.companyTaxId = 'Company Tax ID is Required'
    }

    if (!this.state.companyStreet1) {
      isValid = false
      errors.companyStreet1 = 'Company Address is Required'
    }

    if (!this.state.companyUrl) {
      isValid = false
      errors.companyUrl = 'Company URL is Required'
    }

    if (!this.state.companyCity) {
      isValid = false
      errors.companyCity = 'Company City is Required'
    }

    if (!this.state.companyState) {
      isValid = false
      errors.companyState = 'Company State is Required'
    }

    if (!this.state.companyZip) {
      isValid = false
      errors.companyZip = 'Company Zip Code is Required'
    }

    if (!isValid) {
      this.setState({ errors })
    } else {
      this.setState({ errors: {} })
    }

    return isValid
  }

  handleSubmit = () => {
    if (this.isValid()) {
      const { uid: userId } = this.props.user
      const {
        name,
        phone,
        email,
        companyId,
        companyName,
        companyTaxId,
        companyLicense,
        companyStreet1,
        companyStreet2,
        companyCity,
        companyState,
        companyZip,
        companyUrl,
        billingTerm,
      } = this.state

      let billingPlanPeriod = ''

      if (billingTerm === 1) billingPlanPeriod = 'Monthly'
      else if (billingTerm === 6) billingPlanPeriod = 'Six Months'
      else billingPlanPeriod = 'Annually'

      const profileName = companyName
      const profileUrl = `${process.env.REACT_APP_NUGL_HOST}/listings/${companyId}`

      const request = {
        contactName: name,
        contactPhone: phone,
        contactEmail: email,
        companyName,
        companyTaxId,
        companyLicense,
        companyStreet1,
        companyStreet2,
        companyCity,
        companyState,
        companyZip,
        companyUrl,
        billingPlanPeriod,
        profileName,
        profileUrl,
      }
      firestore
        .collection('upgrades')
        .add({ ...request, userId, createdOn: new Date() })
        .then(() => {
          this.props.success('Thank you. Your request has been submitted.')
          this.props.onClose()
        })
    }
  }

  render() {
    const { open, onClose, classes } = this.props
    return (
      <Dialog
        scroll={'body'}
        className={classes.main}
        open={open}
        aria-labelledby="upgrade-dialog-title"
        aria-describedby="upgrade-dialog-description"
      >
        <Fragment>
          <img
            src={HeaderImage}
            className={classes.headerImage}
            alt="preview"
          />
          <DialogContent className={classes.content}>
            <DialogContentText id="upgrade-dialog-description">
              <Typography variant="h5" gutterBottom>
                Get your business featured in the NUGL app.
              </Typography>

              <Typography
                variant="caption"
                className={classes.caption}
                gutterBottom
              >
                Featured Profiles are the latest upgrade to your NUGL account.
                Make sure you stand out from the rest and upgrade your account
                today!
              </Typography>

              <Typography variant="h6" style={{ fontWeight: 'normal' }}>
                What you get with a featured profile:
              </Typography>
              <Typography
                variant="caption"
                className={classes.caption}
                gutterBottom
              >
                <ul>
                  <li>NUGL home page featured profile placement.</li>
                  <li>Featured profile listing in search results.</li>
                  <li>Larger, pulsing location pin on the map.</li>
                </ul>
                <b>Summer Special!</b> Pricing starting as low as $19/mo. Please
                fill out your details below and a representative will contact
                you shortly.
              </Typography>
              <FormControl
                className={classes.formControl}
                variant="outlined"
                fullWidth
              >
                <FormLabel className={classes.formLabel}>
                  Contact Information
                </FormLabel>
                <div className={classes.inputContainer}>
                  <TextField
                    id="name"
                    label="Contact Name"
                    className={classes.sideMargins}
                    value={this.state.name || ''}
                    onChange={this.handleChange('name')}
                    error={!!this.state.errors.name}
                    helperText={this.state.errors.name}
                    margin="normal"
                    fullWidth
                  />
                </div>
                <div className={classes.inputContainer}>
                  <TextField
                    id="phone"
                    label="Phone Number"
                    className={classes.sideMargins}
                    value={this.state.phone || ''}
                    onChange={this.handleChange('phone')}
                    error={!!this.state.errors.phone}
                    helperText={this.state.errors.phone}
                    margin="normal"
                    fullWidth
                  />
                </div>
                <div className={classes.inputContainer}>
                  <TextField
                    id="email"
                    label="Email"
                    className={classes.sideMargins}
                    value={this.state.email || ''}
                    onChange={this.handleChange('email')}
                    error={!!this.state.errors.email}
                    helperText={this.state.errors.email}
                    margin="normal"
                    fullWidth
                  />
                </div>
              </FormControl>
              <FormControl
                className={classes.formControl}
                variant="outlined"
                fullWidth
              >
                <FormLabel className={classes.formLabel}>
                  Company Information
                </FormLabel>
                <div className={classes.inputContainer}>
                  <TextField
                    id="companyName"
                    label="Legal Company Name"
                    className={classes.sideMargins}
                    value={this.state.companyName || ''}
                    onChange={this.handleChange('companyName')}
                    error={!!this.state.errors.companyName}
                    helperText={this.state.errors.companyName}
                    margin="normal"
                    fullWidth
                  />
                </div>
                <div className={classes.inputContainer}>
                  <TextField
                    id="companyUrl"
                    label="Company URL"
                    className={classes.sideMargins}
                    value={this.state.companyUrl || ''}
                    onChange={this.handleChange('companyUrl')}
                    error={!!this.state.errors.companyUrl}
                    helperText={this.state.errors.companyUrl}
                    margin="normal"
                    fullWidth
                  />
                </div>
                <div className={classes.inputContainer}>
                  <TextField
                    id="companyTaxId"
                    label="Tax ID"
                    className={classes.sideMargins}
                    value={this.state.companyTaxId || ''}
                    onChange={this.handleChange('companyTaxId')}
                    error={!!this.state.errors.companyTaxId}
                    helperText={this.state.errors.companyTaxId}
                    margin="normal"
                    fullWidth
                  />
                </div>
                <div className={classes.inputContainer}>
                  <TextField
                    id="companyLicense"
                    label="License ID orr N/A"
                    className={classes.sideMargins}
                    value={this.state.companyLicense || ''}
                    onChange={this.handleChange('companyLicense')}
                    error={!!this.state.errors.companyLicense}
                    helperText={this.state.errors.companyLicense}
                    margin="normal"
                    fullWidth
                  />
                </div>
                <div className={classes.inputContainer}>
                  <TextField
                    id="companyStreet1"
                    label="Street #1"
                    className={classes.sideMargins}
                    value={this.state.companyStreet1 || ''}
                    onChange={this.handleChange('companyStreet1')}
                    error={!!this.state.errors.companyStreet1}
                    helperText={this.state.errors.companyStreet1}
                    margin="normal"
                    fullWidth
                  />
                </div>
                <div className={classes.inputContainer}>
                  <TextField
                    id="companyStreet2"
                    label="Street #2"
                    value={this.state.companyStreet2}
                    onChange={this.handleChange('companyStreet2')}
                    error={!!this.state.errors.companyStreet2}
                    helperText={this.state.errors.companyStreet2}
                    margin="normal"
                    fullWidth
                  />
                </div>
                <div className={classes.inputContainer}>
                  <TextField
                    id="companyCity"
                    className={classes.location}
                    label="Company City"
                    value={this.state.companyCity}
                    onChange={this.handleChange('companyCity')}
                    error={!!this.state.errors.companyCity}
                    helperText={this.state.errors.companyCity}
                    margin="normal"
                  />
                  <TextField
                    id="companyState"
                    className={classes.location}
                    label="Company State"
                    value={this.state.companyState}
                    onChange={this.handleChange('companyState')}
                    error={!!this.state.errors.companyState}
                    helperText={this.state.errors.companyState}
                    margin="normal"
                  />
                  <TextField
                    id="companyZip"
                    className={classes.location}
                    label="Company Zip Code"
                    value={this.state.companyZip}
                    onChange={this.handleChange('companyZip')}
                    error={!!this.state.errors.companyZip}
                    helperText={this.state.errors.companyZip}
                    margin="normal"
                  />
                </div>
              </FormControl>
              <FormControl
                className={classes.formControl}
                variant="outlined"
                fullWidth
              >
                <FormLabel className={classes.formLabel}>
                  Subscription Confirmation
                </FormLabel>
                <div className={classes.inputContainer}>
                  <TextField
                    id="billingTerm"
                    select
                    label="Billing Term"
                    className={classes.sideMargins}
                    value={this.state.billingTerm}
                    onChange={this.handleChange('billingTerm')}
                    SelectProps={{
                      MenuProps: {
                        className: classes.menu,
                      },
                    }}
                    error={!!this.state.errors.billingTerm}
                    helperText={this.state.errors.billingTerm}
                    margin="normal"
                    fullWidth
                  >
                    <MenuItem key={1} value={1}>
                      $20 per month
                    </MenuItem>
                    <MenuItem key={6} value={6}>
                      $100 per 6 months (Save 15%)
                    </MenuItem>
                    <MenuItem key={12} value={12}>
                      $190 annually (Most Popular - Save 20%)
                    </MenuItem>
                  </TextField>
                </div>
                <Typography
                  variant="caption"
                  className={classes.activate}
                  gutterBottom
                >
                  NUGL Inc will send you a payment link to activate your
                  subscription after confirming the above subscription
                  information and company information
                </Typography>
              </FormControl>
              <div className={classes.termsContainer}>
                <Typography
                  variant="caption"
                  className={classes.terms}
                  gutterBottom
                >
                  By clicking I Agree, you authorize NUGL Inc to bill you
                  according to the terms of service above. An confirmation copy
                  will be emailed to you at the address you provided.
                </Typography>
              </div>
            </DialogContentText>
          </DialogContent>
        </Fragment>

        <DialogActions className={classes.actions}>
          <Button size="small" color="secondary" onClick={onClose}>
            Cancel
          </Button>

          <Button size="small" color="primary" onClick={this.handleSubmit}>
            I Agree
            <KeyboardArrowRight />
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

UpgradeDialog.propTypes = {
  open: PropTypes.bool.isRequired,
}

function mapStateToProps(state) {
  return {
    user: state.user,
  }
}

export default connect(
  mapStateToProps,
  { success },
)(
  withStyles(styles, { withTheme: true })(
    withMobileDialog()(withRouter(UpgradeDialog)),
  ),
)



// WEBPACK FOOTER //
// ./src/components/common/UpgradeDialog/index.jsx